import React from "react";
import "./AboutusHome.css";
import NavBar from "../components/Nav";
import Footer from "../components/footer";
import collab from "../Images/team.png";
import Upperbox from "../components/Upperbox";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";
import Cosection from "../components/Cosections";
import { Link } from "react-router-dom";


// ✅ Icons — ALL UNIQUE (no repetition anywhere)
import {
  FaBrain,
  FaSearchDollar,
  FaBug,
  FaShieldAlt,
  FaFolderOpen,
  FaCalendarCheck,
  FaProjectDiagram,
  FaHandshake,
  FaSyncAlt,
  FaMoneyBillWave,
  FaGavel,
  FaBriefcase,
  FaGlobeAmericas,
  FaExclamationTriangle,
  FaPiggyBank,
} from "react-icons/fa";

const AboutusHome = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="aboutus-page-wrapper">
      <NavBar />

      {/* Hero Banner */}
      <div className="aboutus-hero">
        <div className="aboutus-hero-content">
          <h1 className="aboutus-hero-title">Stop Overpaying Taxes. Keep More of Your Money.</h1>
          <p className="aboutus-hero-subtitle">
            While most tax preparers just file your returns, we find hidden deductions that put thousands back in your pocket every year.
          </p>
          <div className="hero-cta">
            <span className="cta-text">Our average client saves $3,247 more than with other tax preparers</span>
          </div>
        </div>
        <div className="aboutus-hero-overlay"></div>
      </div>

      <div className="aboutus-content-wrapper">
        {/* Results Section */}
        <div className="results-section">
          <div className="results-grid">
            <div className="result-item">
              <div className="result-number">$8.2M+</div>
              <div className="result-label">Total Client Tax Savings</div>
            </div>
            <div className="result-item">
              <div className="result-number">40%</div>
              <div className="result-label">Average Larger Refunds</div>
            </div>
            <div className="result-item">
              <div className="result-number">500+</div>
              <div className="result-label">Audits Successfully Handled</div>
            </div>
            <div className="result-item">
              <div className="result-number">99.7%</div>
              <div className="result-label">Happy Clients</div>
            </div>
          </div>
        </div>

        {/* The Problem & Solution */}
        <div className="problem-solution-section">
          <div className="problem-side">
            <h2>Common Tax Frustrations</h2>

            <div className="pain-points">
              <div className="pain-point">
                <FaBrain className="pain-icon" />
                <div>
                  <h4>Too Complicated</h4>
                  <p>Tax rules keep changing, making it hard to know what you can actually deduct</p>
                </div>
              </div>

              <div className="pain-point">
                <FaSearchDollar className="pain-icon" />
                <div>
                  <h4>Missing Out on Money</h4>
                  <p>Many tax preparers overlook deductions you qualify for</p>
                </div>
              </div>

              <div className="pain-point">
                <FaBug className="pain-icon" />
                <div>
                  <h4>Worry About Audits</h4>
                  <p>The fear of IRS review stops you from claiming what you deserve</p>
                </div>
              </div>
            </div>
          </div>

          <div className="solution-side">
            <h2>How We Make Taxes Easier</h2>

            <div className="solution-benefits">
              <div className="benefit-item">
                <FaShieldAlt className="benefit-icon" />
                <div>
                  <h4>Thorough Review</h4>
                  <p>We find deductions other tax companies miss by asking the right questions</p>
                </div>
              </div>

              <div className="benefit-item">
                <FaFolderOpen className="benefit-icon" />
                <div>
                  <h4>Audit Protection</h4>
                  <p>We keep detailed records so you can claim all you're owed with confidence</p>
                </div>
              </div>

              <div className="benefit-item">
                <FaCalendarCheck className="benefit-icon" />
                <div>
                  <h4>Year-Round Planning</h4>
                  <p>We help you plan ahead to keep your tax bill low every year</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Our Story */}
        <div className="story-section">
          <div className="story-content">
            <h2>Our Story</h2>
            <p className="story-lead">
              We started Easy Tax Experts after seeing too many hardworking Professionals overpay on taxes because they didn't have proper guidance.
            </p>
            <div className="story-highlight">
              <p><strong>Here's what changed everything:</strong> A client came to us after five years with a big tax company. In one review, we found $28,500 in missed deductions — money that could have helped grow their business.</p>
            </div>
            <p>Many preparers rush returns without understanding your situation. We created Easy Tax Experts to be different — the tax partner you can count on.</p>
          </div>

          <div className="story-image">
            <img src={collab} alt="Our Story" />
          </div>
        </div>

        {/* Our Difference */}
        <div className="difference-section">
          <h2>What Makes Us Different</h2>

          <div className="difference-grid">
            <div className="difference-card">
              <FaProjectDiagram className="difference-icon" />
              <h3>We Plan, Not Just File</h3>
              <p>We look at your entire financial picture to find hidden tax-saving opportunities.</p>
            </div>

            <div className="difference-card">
              <FaHandshake className="difference-icon" />
              <h3>We Stand By You</h3>
              <p>If the IRS has questions, we're here with documentation and expert support.</p>
            </div>

            <div className="difference-card">
              <FaSyncAlt className="difference-icon" />
              <h3>Always Current</h3>
              <p>We stay updated on tax law changes so you benefit first.</p>
            </div>
          </div>
        </div>

        {/* Services */}
        <div className="services-section">
          <div className="services-header">
            <h2>Our Tax Services</h2>
            <p>Complete tax help designed to maximize your refund and minimize your stress</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <FaMoneyBillWave className="service-icon" />
              <h4>Bigger Refunds</h4>
              <p>We find every deduction you qualify for.</p>
              <div className="service-result">Clients typically get 40% larger refunds</div>
            </div>

            <div className="service-card">
              <FaGavel className="service-icon" />
              <h4>IRS Help</h4>
              <p>We handle IRS letters and audits for you.</p>
              <div className="service-result">99% audits resolved favorably</div>
            </div>

            <div className="service-card">
              <FaBriefcase className="service-icon" />
              <h4>Business Tax Help</h4>
              <p>We find deductions other preparers miss.</p>
              <div className="service-result">Business owners save $15,000 on average</div>
            </div>

            <div className="service-card">
              <FaGlobeAmericas className="service-icon" />
              <h4>International Tax Help</h4>
              <p>Foreign income reporting & penalty prevention.</p>
              <div className="service-result">Zero penalty notices</div>
            </div>

            <div className="service-card">
              <FaExclamationTriangle className="service-icon" />
              <h4>Tax Emergency Help</h4>
              <p>IRS notices or last-minute filing — we're here.</p>
              <div className="service-result">Help available anytime</div>
            </div>

            <div className="service-card">
              <FaPiggyBank className="service-icon" />
              <h4>Wealth Protection</h4>
              <p>Reduce taxes while growing assets.</p>
              <div className="service-result">Multi-year planning included</div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <h2>Ready to Pay Less in Taxes?</h2>
            <p className="cta-subtitle">Get your free Tax Savings Review — no commitment.</p>

            <div className="cta-benefits">
              <div className="cta-benefit">✓ Free tax review</div>
              <div className="cta-benefit">✓ Personalized savings estimate</div>
              <div className="cta-benefit">✓ No pressure to sign up</div>
            </div>
  
                 <Link to="/contact" className="cta-button">
              Get Your Free Tax Review
            </Link>
            
            <p className="cta-note">Expect the best — expert tax filing and savings-focused support.</p>
          </div>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default AboutusHome;
